import styled from 'styled-components';

const sizes = {
  m: '(min-width: 834px)',
};

export const Banner = styled.section`
  background: black;
  color: white;
`;

export const BannerContainer = styled.figure`
  margin: 0 auto;
  max-width: 96vw;
  width: ${({ containerWidth }) => (containerWidth ? containerWidth + 'px' : '100%')};
  display: flex;
  flex-direction: column;
  padding: 1em 0;

  @media ${sizes.m} {
    flex-direction: row;
  }
`;

export const ButtonLink = styled.button`
  display: inline;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  border: 0;
  background: transparent;
  color: white;
`;

export const BannerCopy = styled.div`
  font-family: effra, sans-serif;
  display: flex;
  flex: 1;
  h2 {
    font-size: 1.2em;
  }
  p {
    font-size: 0.8em;
    font-weight: 400;
    line-height: 1.2;

    @media ${sizes.m} {
      font-size: 1em;
    }
  }
`;

export const BannerCopyAside = styled.aside`
  margin-right: 1em;
  padding-top: 0.6em;
`;

export const BannerCopyInner = styled.figcaption`
  flex: 1;
`;

export const BannerActions = styled.menu`
  margin: 0.5em 0;
  display: flex;
  flex-direction: row;
  @media ${sizes.m} {
    margin: 0;
    flex-direction: column;
  }
`;

export const BannerAction = styled.button`
  background: transparent;
  color: white;
  flex: 1;
  cursor: pointer;
  border: 0;
  font-family: effra, sans-serif;
  font-weight: 800;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
  :hover {
    text-decoration: underline;
  }

  svg {
    display: inline-block;
    vertical-align: middle;
    margin-right: 5px;
  }

  @media ${sizes.m} {
    text-align: right;
  }
`;

export CookieBanner from './CookieBanner';
export CookiePreferences from './CookiePreferences';
